import { render, staticRenderFns } from "./CompTableProgressMonth.vue?vue&type=template&id=51075898"
import script from "./CompTableProgressMonth.vue?vue&type=script&lang=js"
export * from "./CompTableProgressMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports